export const CARS_CALIBRATION_TICKERS = ['MRVL', 'GOOGL', 'CAT', 'AMAT', 'PLTR', 'UBER']

export const CARS_CALIBRATION_VARIANTS = [
  { label: 'current', presetParams: {} },
  { label: 'stay_1', presetParams: { cars_v1_min_positive_components_stay_on: 1 } },
  { label: 'enter_0.07', presetParams: { cars_v1_enter_score: 0.07 } },
  { label: 'enter_0.05', presetParams: { cars_v1_enter_score: 0.05 } },
  { label: 'enter_0.00', presetParams: { cars_v1_enter_score: 0.0 } },
  { label: 'components_2', presetParams: { cars_v1_min_positive_components_enter: 2 } },
  {
    label: 'components_2_stay_1',
    presetParams: {
      cars_v1_min_positive_components_enter: 2,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'enter_0.05_components_2_stay_1',
    presetParams: {
      cars_v1_enter_score: 0.05,
      cars_v1_min_positive_components_enter: 2,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'beta_42_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 42,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'beta_21_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 21,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'beta_84_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 84,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'beta_126_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 126,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_short_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [5, 10, 21, 42],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_short_exit_alpha2_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [5, 10, 21, 42],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_exit_alpha_window: 2,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_micro_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [3, 5, 10, 21],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_micro_smooth_3_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [3, 5, 10, 21],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_smoothing_length: 3,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_micro_smooth_2_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [3, 5, 10, 21],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_smoothing_length: 2,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_micro_smooth_2_exit_m0.25_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [3, 5, 10, 21],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_smoothing_length: 2,
      cars_v1_exit_score: -0.25,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_micro_smooth_2_exit_alpha2_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [3, 5, 10, 21],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_smoothing_length: 2,
      cars_v1_exit_alpha_window: 2,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_micro_smooth_2_exit_alpha3_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [3, 5, 10, 21],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_smoothing_length: 2,
      cars_v1_exit_alpha_window: 3,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_micro_exit_m0.25_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [3, 5, 10, 21],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_exit_score: -0.25,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_micro_beta_42_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 42,
      cars_v1_alpha_windows: [3, 5, 10, 21],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_micro_beta_126_smooth_3_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 126,
      cars_v1_alpha_windows: [3, 5, 10, 21],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_smoothing_length: 3,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_micro_beta_126_smooth_3_exit_m0.25_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 126,
      cars_v1_alpha_windows: [3, 5, 10, 21],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_smoothing_length: 3,
      cars_v1_exit_score: -0.25,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_ultra_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [2, 3, 5, 10],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_ultra_smooth_2_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [2, 3, 5, 10],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_smoothing_length: 2,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_ultra_tail21_smooth_2_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [2, 3, 5, 21],
      cars_v1_alpha_weights: [0.15, 0.25, 0.30, 0.30],
      cars_v1_smoothing_length: 2,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_ultra_tail42_smooth_2_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [2, 3, 10, 42],
      cars_v1_alpha_weights: [0.15, 0.25, 0.25, 0.35],
      cars_v1_smoothing_length: 2,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_micro_tail42_smooth_2_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [3, 5, 10, 42],
      cars_v1_alpha_weights: [0.15, 0.25, 0.30, 0.30],
      cars_v1_smoothing_length: 2,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_ultra_smooth_3_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [2, 3, 5, 10],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_smoothing_length: 3,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_ultra_exit_m0.25_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [2, 3, 5, 10],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_exit_score: -0.25,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_ultra_beta_126_smooth_2_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 126,
      cars_v1_alpha_windows: [2, 3, 5, 10],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_smoothing_length: 2,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_ultra_beta_126_smooth_3_exit_m0.25_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 126,
      cars_v1_alpha_windows: [2, 3, 5, 10],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_smoothing_length: 3,
      cars_v1_exit_score: -0.25,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_long_stay_1',
    presetParams: {
      cars_v1_alpha_windows: [21, 42, 63, 126],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_long_beta_126_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 126,
      cars_v1_alpha_windows: [21, 42, 63, 126],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_long_beta_42_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 42,
      cars_v1_alpha_windows: [21, 42, 63, 126],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_long_beta_63_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 63,
      cars_v1_alpha_windows: [21, 42, 63, 126],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_long_beta_84_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 84,
      cars_v1_alpha_windows: [21, 42, 63, 126],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'smooth_1_stay_1',
    presetParams: {
      cars_v1_smoothing_length: 1,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'smooth_10_stay_1',
    presetParams: {
      cars_v1_smoothing_length: 10,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'beta_126_smooth_10_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 126,
      cars_v1_smoothing_length: 10,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'beta_21_smooth_10_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 21,
      cars_v1_smoothing_length: 10,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_blend_beta_126_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 126,
      cars_v1_alpha_windows: [10, 21, 63, 126],
      cars_v1_alpha_weights: [0.10, 0.20, 0.35, 0.35],
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_blend_beta_126_smooth_10_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 126,
      cars_v1_alpha_windows: [10, 21, 63, 126],
      cars_v1_alpha_weights: [0.10, 0.20, 0.35, 0.35],
      cars_v1_smoothing_length: 10,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'rs_level_stay_1',
    presetParams: {
      cars_v1_rs_level_stay_on: true,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'rs_level_entry_gate_1',
    presetParams: {
      cars_v1_rs_level_entry_gate: true,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'rs_level_entry_gate_stay_1',
    presetParams: {
      cars_v1_rs_level_entry_gate: true,
      cars_v1_rs_level_stay_on: true,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_blend_beta_126_smooth_10_rs_level_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 126,
      cars_v1_alpha_windows: [10, 21, 63, 126],
      cars_v1_alpha_weights: [0.10, 0.20, 0.35, 0.35],
      cars_v1_smoothing_length: 10,
      cars_v1_rs_level_stay_on: true,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_short_beta_126_rs_level_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 126,
      cars_v1_alpha_windows: [5, 10, 21, 42],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_rs_level_stay_on: true,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_blend_beta_126_exit_m0.25_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 126,
      cars_v1_alpha_windows: [10, 21, 63, 126],
      cars_v1_alpha_weights: [0.10, 0.20, 0.35, 0.35],
      cars_v1_exit_score: -0.25,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_long_beta_126_exit_m0.25_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 126,
      cars_v1_alpha_windows: [21, 42, 63, 126],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_exit_score: -0.25,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_long_beta_126_exit_m0.25_rs_level_entry_gate_1',
    presetParams: {
      cars_v1_beta_lookback: 126,
      cars_v1_alpha_windows: [21, 42, 63, 126],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_exit_score: -0.25,
      cars_v1_rs_level_entry_gate: true,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_long_beta_42_exit_m0.25_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 42,
      cars_v1_alpha_windows: [21, 42, 63, 126],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_exit_score: -0.25,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_short_beta_126_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 126,
      cars_v1_alpha_windows: [5, 10, 21, 42],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_short_beta_126_exit_m0.25_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 126,
      cars_v1_alpha_windows: [5, 10, 21, 42],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_exit_score: -0.25,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_long_beta_42_exit_m0.25_rs_level_entry_gate_1',
    presetParams: {
      cars_v1_beta_lookback: 42,
      cars_v1_alpha_windows: [21, 42, 63, 126],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_exit_score: -0.25,
      cars_v1_rs_level_entry_gate: true,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
  {
    label: 'alpha_long_beta_42_exit_alpha2_stay_1',
    presetParams: {
      cars_v1_beta_lookback: 42,
      cars_v1_alpha_windows: [21, 42, 63, 126],
      cars_v1_alpha_weights: [0.15, 0.30, 0.30, 0.25],
      cars_v1_exit_alpha_window: 2,
      cars_v1_min_positive_components_stay_on: 1,
    },
  },
]

export const CARS_CALIBRATION_DIAGNOSTIC_VARIANTS = [
  'current',
  'stay_1',
  'beta_84_stay_1',
  'beta_126_stay_1',
  'beta_21_stay_1',
  'alpha_short_stay_1',
  'alpha_short_exit_alpha2_stay_1',
  'alpha_micro_stay_1',
  'alpha_micro_smooth_3_stay_1',
  'alpha_micro_smooth_2_stay_1',
  'alpha_micro_smooth_2_exit_m0.25_stay_1',
  'alpha_micro_smooth_2_exit_alpha2_stay_1',
  'alpha_micro_smooth_2_exit_alpha3_stay_1',
  'alpha_micro_exit_m0.25_stay_1',
  'alpha_micro_beta_42_stay_1',
  'alpha_micro_beta_126_smooth_3_stay_1',
  'alpha_micro_beta_126_smooth_3_exit_m0.25_stay_1',
  'alpha_ultra_stay_1',
  'alpha_ultra_smooth_2_stay_1',
  'alpha_ultra_tail21_smooth_2_stay_1',
  'alpha_ultra_tail42_smooth_2_stay_1',
  'alpha_micro_tail42_smooth_2_stay_1',
  'alpha_ultra_smooth_3_stay_1',
  'alpha_ultra_exit_m0.25_stay_1',
  'alpha_ultra_beta_126_smooth_2_stay_1',
  'alpha_ultra_beta_126_smooth_3_exit_m0.25_stay_1',
  'alpha_long_stay_1',
  'alpha_long_beta_126_stay_1',
  'alpha_long_beta_42_stay_1',
  'alpha_long_beta_63_stay_1',
  'alpha_long_beta_84_stay_1',
  'smooth_1_stay_1',
  'smooth_10_stay_1',
  'beta_126_smooth_10_stay_1',
  'beta_21_smooth_10_stay_1',
  'rs_level_stay_1',
  'rs_level_entry_gate_1',
  'rs_level_entry_gate_stay_1',
  'alpha_blend_beta_126_stay_1',
  'alpha_blend_beta_126_smooth_10_stay_1',
  'alpha_blend_beta_126_smooth_10_rs_level_stay_1',
  'alpha_blend_beta_126_exit_m0.25_stay_1',
  'alpha_long_beta_126_exit_m0.25_stay_1',
  'alpha_long_beta_126_exit_m0.25_rs_level_entry_gate_1',
  'alpha_long_beta_42_exit_m0.25_stay_1',
  'alpha_long_beta_42_exit_m0.25_rs_level_entry_gate_1',
  'alpha_long_beta_42_exit_alpha2_stay_1',
  'alpha_short_beta_126_stay_1',
  'alpha_short_beta_126_rs_level_stay_1',
  'alpha_short_beta_126_exit_m0.25_stay_1',
]

export const CARS_CALIBRATION_ANCHORS = {
  MRVL: [
    { on: '20260223', off: 'present' },
  ],
  GOOGL: [
    { on: '20250721', off: '20250724' },
    { on: '20250730', off: '20260213' },
    { on: '20260312', off: '20260324' },
    { on: '20260331', off: '20260529' },
  ],
  CAT: [
    { on: '20250114', off: '20250116' },
    { on: '20250117', off: '20250130' },
    { on: '20250307', off: '20250311' },
    { on: '20250618', off: 'present' },
  ],
}

const BENCHMARK_SYMBOL = 'SPY'
const DAILY_BAR_SIZE = '1 day'
const ADJUSTED_WHAT_TO_SHOW = 'ADJUSTED_LAST'
const CALIBRATION_DURATION = '5 Y'
const DIAGNOSTIC_BEFORE_DAYS = 28
const DIAGNOSTIC_AFTER_DAYS = 30

function readIbkrDayKey(rawTime) {
  if (typeof rawTime === 'string') {
    const match = rawTime.match(/\d{8}/)
    return match ? match[0] : null
  }
  if (
    typeof rawTime === 'number'
    && Number.isFinite(rawTime)
    && Number.isInteger(rawTime)
    && rawTime >= 19000101
    && rawTime <= 99991231
  ) {
    return String(rawTime)
  }
  return null
}

function epochFromDayKey(dayKey) {
  if (typeof dayKey !== 'string' || !/^\d{8}$/.test(dayKey)) return null
  const y = Number(dayKey.slice(0, 4))
  const m = Number(dayKey.slice(4, 6))
  const d = Number(dayKey.slice(6, 8))
  if (y < 1900 || m < 1 || m > 12 || d < 1 || d > 31) return null
  const epochMs = Date.UTC(y, m - 1, d)
  const dt = new Date(epochMs)
  if (
    dt.getUTCFullYear() !== y
    || dt.getUTCMonth() !== m - 1
    || dt.getUTCDate() !== d
  ) return null
  return Math.floor(epochMs / 1000)
}

function toFiniteNumber(value) {
  if (value == null || value === '') return Number.NaN
  const n = Number(value)
  return Number.isFinite(n) ? n : Number.NaN
}

function toVolume(value) {
  if (value == null || value === '') return 0
  const n = Number(value)
  return Number.isFinite(n) ? n : Number.NaN
}

function normalizeCalibrationBars(bars) {
  return (Array.isArray(bars) ? bars : [])
    .map((bar) => {
      const time = epochFromDayKey(bar.ibkrDayKey)
      const open = toFiniteNumber(bar.open)
      const high = toFiniteNumber(bar.high)
      const low = toFiniteNumber(bar.low)
      const close = toFiniteNumber(bar.close)
      const volume = toVolume(bar.volume)
      if (time == null || ![open, high, low, close, volume].every(Number.isFinite)) return null
      return {
        ibkrDayKey: bar.ibkrDayKey,
        close,
        engineBar: { time, open, high, low, close, volume },
      }
    })
    .filter(Boolean)
}

async function readJsonResponse(response, label) {
  if (!response.ok) {
    let detail = ''
    try { detail = await response.text() } catch { /* noop */ }
    throw new Error(`${label} failed: ${response.status}${detail ? ` ${detail}` : ''}`)
  }
  return response.json()
}

export async function fetchCarsCalibrationDailyBars(symbol, token, fetchImpl = fetch) {
  const params = new URLSearchParams({
    symbol,
    barSize: DAILY_BAR_SIZE,
    duration: CALIBRATION_DURATION,
    whatToShow: ADJUSTED_WHAT_TO_SHOW,
    useRTH: '1',
  })

  const response = await fetchImpl(`/api/ibkr/candles?${params}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
  const json = await readJsonResponse(response, `${symbol} adjusted daily candles`)
  return (Array.isArray(json?.bars) ? json.bars : [])
    .map((bar) => ({ ...bar, ibkrDayKey: readIbkrDayKey(bar.time ?? bar.date ?? bar.ibkrDayKey) }))
    .filter((bar) => bar.ibkrDayKey)
}

async function getCachedCalibrationDailyBars(symbol, token, fetchImpl, barsBySymbol) {
  const key = String(symbol || '').trim().toUpperCase()
  if (!barsBySymbol) return fetchCarsCalibrationDailyBars(key, token, fetchImpl)
  if (!barsBySymbol.has(key)) {
    barsBySymbol.set(key, fetchCarsCalibrationDailyBars(key, token, fetchImpl))
  }
  return barsBySymbol.get(key)
}

export function buildCarsCalibrationTransitions(rows, variant) {
  const transitions = []
  let wasOn = false

  for (const row of Array.isArray(rows) ? rows : []) {
    const on = row.rawRegime === true
    if (on !== wasOn) {
      transitions.push({
        variant,
        date: row.date,
        event: on ? 'ON' : 'OFF',
        score: row.score,
      })
    }
    wasOn = on
  }

  return transitions
}

export function buildCarsCalibrationSpans(rows, variant) {
  const spans = []
  let start = null

  for (const row of Array.isArray(rows) ? rows : []) {
    const on = row.rawRegime === true
    if (on && !start) start = row.date
    if (!on && start) {
      spans.push({ variant, on: start, off: row.date, off_is_first_false_day: true })
      start = null
    }
  }

  if (start) spans.push({ variant, on: start, off: 'present' })
  return spans
}

function dateIndex(dayKey) {
  if (dayKey === 'present') return 1_000_000
  const epoch = epochFromDayKey(dayKey)
  return epoch == null ? null : Math.floor(epoch / 86400)
}

function dayKeyFromDateIndex(index) {
  if (!Number.isFinite(index)) return null
  const dt = new Date(index * 86400 * 1000)
  const year = dt.getUTCFullYear()
  const month = String(dt.getUTCMonth() + 1).padStart(2, '0')
  const day = String(dt.getUTCDate()).padStart(2, '0')
  return `${year}${month}${day}`
}

function shiftDayKey(dayKey, days) {
  const index = dateIndex(dayKey)
  if (index == null || index === 1_000_000) return null
  return dayKeyFromDateIndex(index + days)
}

function distanceDays(a, b) {
  const ai = dateIndex(a)
  const bi = dateIndex(b)
  if (ai == null || bi == null) return 365
  return Math.abs(ai - bi)
}

function roundNullableNumber(value, digits = 3) {
  if (value == null) return null
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return null
  return Number(numeric.toFixed(digits))
}

export function buildCarsCalibrationDiagnosticWindows(
  anchors = [],
  beforeDays = DIAGNOSTIC_BEFORE_DAYS,
  afterDays = DIAGNOSTIC_AFTER_DAYS,
  latestDayKey = null,
) {
  const latestIndex = dateIndex(latestDayKey)
  const windows = (Array.isArray(anchors) ? anchors : [])
    .map((anchor) => {
      const start = shiftDayKey(anchor?.on, -beforeDays)
      const anchorOnIndex = dateIndex(anchor?.on)
      const hasLatestForPresent = (
        anchor?.off === 'present'
        && latestIndex != null
        && anchorOnIndex != null
        && latestIndex >= anchorOnIndex
      )
      const end = hasLatestForPresent
        ? latestDayKey
        : shiftDayKey(anchor?.off === 'present' ? anchor?.on : anchor?.off, afterDays)
      if (!start || !end) return null
      return { start, end }
    })
    .filter(Boolean)
    .sort((a, b) => dateIndex(a.start) - dateIndex(b.start))

  const merged = []
  for (const window of windows) {
    const last = merged.at(-1)
    if (!last || dateIndex(window.start) > dateIndex(last.end) + 1) {
      merged.push({ ...window })
    } else if (dateIndex(window.end) > dateIndex(last.end)) {
      last.end = window.end
    }
  }
  return merged
}

export function buildCarsCalibrationDiagnosticRows(rows = [], anchors = []) {
  const latestDayKey = (Array.isArray(rows) ? rows : [])
    .map((row) => row?.date)
    .filter((dayKey) => dateIndex(dayKey) != null)
    .at(-1) || null
  const windows = buildCarsCalibrationDiagnosticWindows(
    anchors,
    DIAGNOSTIC_BEFORE_DAYS,
    DIAGNOSTIC_AFTER_DAYS,
    latestDayKey,
  )
  if (!windows.length) return { windows: [], rows: [] }

  const diagnosticRows = (Array.isArray(rows) ? rows : [])
    .filter((row) => {
      const rowIndex = dateIndex(row?.date)
      if (rowIndex == null) return false
      return windows.some((window) => (
        rowIndex >= dateIndex(window.start) && rowIndex <= dateIndex(window.end)
      ))
    })
    .map((row) => ({
      date: row.date,
      close: row.close,
      spyClose: row.spyClose,
      rawRegime: row.rawRegime,
      regime: row.regime,
      score: row.score,
      beta: row.beta,
      stockReturn: row.stockReturn,
      benchmarkReturn: row.benchmarkReturn,
      expectedReturn: row.expectedReturn,
      alpha: row.alpha,
      components: row.components,
      componentPositive: row.componentPositive,
      rawScore: row.rawScore,
      smoothedScore: row.smoothedScore,
      rsLevel: row.rsLevel,
      rsLevelComponents: row.rsLevelComponents,
    }))

  return { windows, rows: diagnosticRows }
}

export function scoreCarsCalibrationSpans(spans, anchors = []) {
  const candidateSpans = Array.isArray(spans) ? spans : []
  const anchorSpans = Array.isArray(anchors) ? anchors : []
  let total = 0
  let matched = 0

  for (const anchor of anchorSpans) {
    let best = null
    for (const span of candidateSpans) {
      const score = distanceDays(span.on, anchor.on) + distanceDays(span.off, anchor.off)
      if (best == null || score < best) best = score
    }
    if (best == null) {
      total += 730
    } else {
      total += best
      if (best <= 5) matched += 1
    }
  }

  const extraSpans = Math.max(0, candidateSpans.length - anchorSpans.length)
  total += extraSpans * 20

  return {
    total,
    matchedAnchors: matched,
    missedAnchors: Math.max(0, anchorSpans.length - matched),
    extraSpans,
  }
}

export async function runCarsCalibrationVariant({
  symbol,
  variant,
  token,
  anchors = [],
  fetchImpl = fetch,
  barsBySymbol = null,
}) {
  const [primaryBars, benchmarkBars] = await Promise.all([
    getCachedCalibrationDailyBars(symbol, token, fetchImpl, barsBySymbol),
    getCachedCalibrationDailyBars(BENCHMARK_SYMBOL, token, fetchImpl, barsBySymbol),
  ])
  const normalizedPrimaryBars = normalizeCalibrationBars(primaryBars)
  const normalizedBenchmarkBars = normalizeCalibrationBars(benchmarkBars)
  const benchmarkCloseByDate = new Map(
    normalizedBenchmarkBars.map((bar) => [bar.ibkrDayKey, bar.close]),
  )
  const presetParams = variant?.presetParams || {}
  const variantLabel = variant?.label || 'current'

  const response = await fetchImpl('/api/engine/indicators', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      bars: normalizedPrimaryBars.map((bar) => bar.engineBar),
      bar_size: DAILY_BAR_SIZE,
      application_snapshot: {
        asset_class: 'equity',
        preset_params: presetParams,
      },
      enabled_indicators: ['cars_v1'],
      benchmark_bars_by_symbol: {
        [BENCHMARK_SYMBOL]: normalizedBenchmarkBars.map((bar) => bar.engineBar),
      },
    }),
  })

  const json = await readJsonResponse(response, `${symbol} ${variantLabel} CA|RS engine`)
  const regime = Array.isArray(json?.indicators?.cars_v1_regime)
    ? json.indicators.cars_v1_regime
    : []
  const score = Array.isArray(json?.indicators?.cars_v1_score)
    ? json.indicators.cars_v1_score
    : []
  const beta = Array.isArray(json?.indicators?.cars_v1_beta)
    ? json.indicators.cars_v1_beta
    : []
  const stockReturn = Array.isArray(json?.indicators?.cars_v1_stock_return)
    ? json.indicators.cars_v1_stock_return
    : []
  const benchmarkReturn = Array.isArray(json?.indicators?.cars_v1_benchmark_return)
    ? json.indicators.cars_v1_benchmark_return
    : []
  const expectedReturn = Array.isArray(json?.indicators?.cars_v1_expected_return)
    ? json.indicators.cars_v1_expected_return
    : []
  const alpha = Array.isArray(json?.indicators?.cars_v1_alpha)
    ? json.indicators.cars_v1_alpha
    : []
  const components = Array.isArray(json?.indicators?.cars_v1_components)
    ? json.indicators.cars_v1_components
    : []
  const componentPositive = Array.isArray(json?.indicators?.cars_v1_component_positive)
    ? json.indicators.cars_v1_component_positive
    : []
  const rawScore = Array.isArray(json?.indicators?.cars_v1_raw_score)
    ? json.indicators.cars_v1_raw_score
    : []
  const smoothedScore = Array.isArray(json?.indicators?.cars_v1_smoothed_score)
    ? json.indicators.cars_v1_smoothed_score
    : []
  const rsLevel = Array.isArray(json?.indicators?.cars_v1_rs_level)
    ? json.indicators.cars_v1_rs_level
    : []
  const rsLevelComponents = Array.isArray(json?.indicators?.cars_v1_rs_level_components)
    ? json.indicators.cars_v1_rs_level_components
    : []

  const rows = normalizedPrimaryBars.map((bar, i) => {
    const scoreValue = score[i]
    return {
      date: bar.ibkrDayKey,
      close: bar.close,
      spyClose: benchmarkCloseByDate.get(bar.ibkrDayKey) ?? null,
      rawRegime: regime[i],
      regime: regime[i] === true,
      score: roundNullableNumber(scoreValue),
      beta: roundNullableNumber(beta[i]),
      stockReturn: roundNullableNumber(stockReturn[i], 6),
      benchmarkReturn: roundNullableNumber(benchmarkReturn[i], 6),
      expectedReturn: roundNullableNumber(expectedReturn[i], 6),
      alpha: roundNullableNumber(alpha[i], 6),
      components: Array.isArray(components[i])
        ? components[i].map((value) => roundNullableNumber(value))
        : null,
      componentPositive: roundNullableNumber(componentPositive[i], 0),
      rawScore: roundNullableNumber(rawScore[i]),
      smoothedScore: roundNullableNumber(smoothedScore[i]),
      rsLevel: roundNullableNumber(rsLevel[i], 6),
      rsLevelComponents: Array.isArray(rsLevelComponents[i])
        ? rsLevelComponents[i].map((value) => roundNullableNumber(value, 6))
        : null,
    }
  })
  const transitions = buildCarsCalibrationTransitions(rows, variantLabel)
  const spans = buildCarsCalibrationSpans(rows, variantLabel)

  return {
    symbol,
    variant: variantLabel,
    presetParams,
    inputAudit: {
      symbol,
      primaryBars: primaryBars.length,
      benchmarkBars: benchmarkBars.length,
      firstPrimary: primaryBars[0]?.ibkrDayKey ?? null,
      lastPrimary: primaryBars.at(-1)?.ibkrDayKey ?? null,
      firstBenchmark: benchmarkBars[0]?.ibkrDayKey ?? null,
      lastBenchmark: benchmarkBars.at(-1)?.ibkrDayKey ?? null,
      whatToShow: ADJUSTED_WHAT_TO_SHOW,
      duration: CALIBRATION_DURATION,
      benchmark: BENCHMARK_SYMBOL,
    },
    rows,
    transitions,
    spans,
    score: anchors.length ? scoreCarsCalibrationSpans(spans, anchors) : null,
    json,
  }
}

export async function runCarsCalibration({
  symbols = CARS_CALIBRATION_TICKERS,
  variants = CARS_CALIBRATION_VARIANTS,
  anchorsBySymbol = CARS_CALIBRATION_ANCHORS,
  token,
  fetchImpl = fetch,
}) {
  if (!token) throw new Error('Missing Supabase access token')
  const results = []
  const barsBySymbol = new Map()

  for (const symbol of symbols) {
    const normalizedSymbol = String(symbol || '').trim().toUpperCase()
    if (!normalizedSymbol) continue
    for (const variant of variants) {
      results.push(await runCarsCalibrationVariant({
        symbol: normalizedSymbol,
        variant,
        token,
        anchors: anchorsBySymbol?.[normalizedSymbol] || [],
        fetchImpl,
        barsBySymbol,
      }))
    }
  }

  return results
}
